.createNewBoxButton {
  margin: 20px;
}

.boxEditRow {
  padding: 1rem;
}

.boxEditRow:not(:last-child) {
  border-bottom: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
}

.topRow {
  margin-top: 10px;
  margin-bottom: 20px;
  margin-left: 16px;
}

.modal {
  width: min(80rem, 70vw);
}

.bulkDimsModal {
  position: relative;
  overflow-y: auto;
  max-height: 60vh;
}

.modalFooter {
  bottom: 0;
  position: sticky;
}

.modalHeader {
  top: 0;
  position: sticky;
}

.allBoxesCheckedLabel {
  margin: 0 16px;
}

.allBoxesCheckedCheckbox {
  margin-right: 1ch;
}

.applyToAllButton {
  margin-bottom: 8px;
}